import { useTheme } from "@mui/material";

/**
 * The app-bar wordmark: the brand name split after its first word-part ("Tele|Headache",
 * "Cerebra|Linked"), coloured from `palette.brand.wordmark`. A name with no known split is shown
 * whole in the `rest` colour.
 */
const WORDMARK_LEADS = ["Tele", "Cerebra"];
export function Wordmark({ name }: { name: string }) {
  const { wordmark } = useTheme().palette.brand;
  const lead = WORDMARK_LEADS.find((l) => name.startsWith(l) && name.length > l.length);
  if (!lead) return <span style={{ color: wordmark.rest }}>{name}</span>;
  return (
    <>
      <span style={{ color: wordmark.lead }}>{lead}</span>
      <span style={{ color: wordmark.rest }}>{name.slice(lead.length)}</span>
    </>
  );
}
